import React from 'react';
import { Text, View } from '@react-pdf/renderer';

interface ComponentProps {
  title: string;
  children: React.ReactNode;
  styles: {
    section: any;
    sectionTitle: any;
    detailsContainer: any;
  };
}

export const Section: React.FC<ComponentProps> = ({ title, children, styles }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>{title}</Text>
      <View style={styles.detailsContainer}>{children}</View>
    </View>
  );
};
